// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"qE","carousel__wrapper_on_sides":"rE","arrows_wrapper":"sE","arrows_wrapper_right":"tE","arrows_wrapper_vertical":"uE","arrows_wrapper_on_sides":"vE","arrow_button":"wE","carousel_arrow_left":"xE","carousel_arrow_left_on_side":"yE","carousel_arrow_right_on_side":"zE","carousel_arrow":"AE","arrows_wrapper_rounded":"BE","carousel__fullWidth":"CE"};
    if(module.hot) {
      // 1726593106246
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  